import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';

export const EndpointHistoryTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:date')}
        thClassName="min-w-[150px]"
        sortable
        onSortClick={() => onSort?.('createdAt')}
      />
      <TableHead
        text={`${t('common:licensePlateNumber')} & ${t('common:vin')}`}
        thClassName="w-[230px] max-sm:min-w-[170px]"
        onSortClick={() => onSort?.('licensePlateAndVin')}
      />
      <TableHead
        text={t('common:client')}
        thClassName="w-[215px] max-sm:min-w-[200px]"
      />
      <TableHead
        text={t('endpointHistory:method')}
        thClassName="text-center min-w-0 w-0"
      />
      <TableHead
        text={t('endpointHistory:schema')}
        thClassName="max-sm:min-w-[170px]"
      />
      <TableHead
        text={t('endpointHistory:urlWithValues')}
        thClassName="max-sm:min-w-[170px]"
      />
    </>
  );
};
